var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgFeedbackFinish = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 59 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6728FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M29.495 53.167c13.347 0 24.166-10.82 24.166-24.166 0-13.347-10.82-24.167-24.166-24.167-13.347 0-24.167 10.82-24.167 24.167 0 13.346 10.82 24.166 24.167 24.166Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6728FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.6,
    d: "M38.5 24 27.079 35 20.5 28.67"
  })));
});
SvgFeedbackFinish.displayName = "SvgFeedbackFinish";
export default SvgFeedbackFinish;